import { SalesReportReturnType } from '../ordering-service.types';

export const salesReport: SalesReportReturnType = {
  orders: [
    {
      orderId: '64a6e822e4b00e3d860ceb5a',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: '8f9ac172-6d73-4814-a024-89d71ecd6b00',
      customer: {
        firstName: 'Test',
        lastName: 'test',
        phone: '7777777444',
        email: null,
      },
      createdDate: '2023-07-06T21:43:22.212',
      localCreatedDate: '2023-07-06T21:43:22.213',
      updatedDate: '2023-07-06T21:43:46.873',
      orderTotal: {
        preDiscountSubtotal: 25560,
        subtotal: 25560,
        total: 27290,
        displayTotal: '27.29',
        displaySubtotal: '25.56',
        displayPreDiscountSubtotal: '25.56',
      },
      orderFulfillTime: '2023-07-06T21:48:46',
      closedTime: '2023-07-06T16:13:46',
      localClosedTime: '2023-07-06T21:43:46.873',
      status: 'CLOSED',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'APP',
      filterStatus: 'CLOSED_ORDERS',
    },
    {
      orderId: '64a6c432e4b00e3d860ceb49',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: 'c3c4118c-337b-4124-aee5-ec375c4c4b6c',
      customer: {
        firstName: 'Roy99',
        lastName: 'Justinnn',
        phone: '2321321323',
        email: 'test@gmail.com',
      },
      createdDate: '2023-07-06T19:10:02.254',
      localCreatedDate: '2023-07-06T19:10:02.262',
      updatedDate: '2023-07-06T19:10:28.791',
      orderTotal: {
        preDiscountSubtotal: 9990,
        subtotal: 9990,
        total: 10660,
        displayTotal: '10.66',
        displaySubtotal: '9.99',
        displayPreDiscountSubtotal: '9.99',
      },
      orderFulfillTime: '2023-07-06T19:15:28',
      closedTime: '2023-07-06T13:40:28',
      localClosedTime: '2023-07-06T19:10:28.791',
      status: 'CLOSED',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'WEB',
      filterStatus: 'TEST_ORDERS',
    },
    {
      orderId: '64a6c3fde4b00e3d860ceb32',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: 'd3c0af1a-c263-4443-8985-d774f2cae6db',
      customer: {
        firstName: 'Roy99',
        lastName: 'Justinnn',
        phone: '2321321323',
        email: null,
      },
      createdDate: '2023-07-06T19:09:09.324',
      localCreatedDate: '2023-07-06T19:09:09.327',
      updatedDate: '2023-07-06T19:09:50.174',
      orderTotal: {
        preDiscountSubtotal: 28980,
        subtotal: 28980,
        total: 30950,
        displayTotal: '30.95',
        displaySubtotal: '28.98',
        displayPreDiscountSubtotal: '28.98',
      },
      orderFulfillTime: '2023-07-06T19:14:49',
      closedTime: '2023-07-06T13:39:50',
      localClosedTime: '2023-07-06T19:09:50.175',
      status: 'OPEN',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'WEB',
      filterStatus: 'ABANDONED_ORDERS',
    },
    {
      orderId: '64a6baa4e4b03d4d1e5c8e98',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: 'd3e8bd49-dbfe-482d-8e57-aac4a286fd3c',
      customer: {
        firstName: 'Roy99',
        lastName: 'Justinnn',
        phone: '2321321323',
        email: null,
      },
      createdDate: '2023-07-06T18:29:16.247',
      localCreatedDate: '2023-07-06T18:29:16.248',
      updatedDate: '2023-07-06T18:29:50.094',
      orderTotal: {
        preDiscountSubtotal: 25990,
        subtotal: 25990,
        total: 27740,
        displayTotal: '27.74',
        displaySubtotal: '25.99',
        displayPreDiscountSubtotal: '25.99',
      },
      orderFulfillTime: '2023-07-06T18:34:49',
      closedTime: '2023-07-06T12:59:50',
      localClosedTime: '2023-07-06T18:29:50.094',
      status: 'CLOSED',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'WEB',
      filterStatus: 'CLOSED_ORDERS',
    },
    {
      orderId: '64a6ba73e4b03d4d1e5c8e86',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: '2a247689-b41d-4d1b-96b9-1b3dd7d003fa',
      customer: {
        firstName: 'Roy99',
        lastName: 'Justinnn',
        phone: '2321321323',
        email: null,
      },
      createdDate: '2023-07-06T18:28:27.367',
      localCreatedDate: '2023-07-06T18:28:27.369',
      updatedDate: '2023-07-06T18:29:03.811',
      orderTotal: {
        preDiscountSubtotal: 15000,
        subtotal: 15000,
        total: 16020,
        displayTotal: '16.02',
        displaySubtotal: '15.00',
        displayPreDiscountSubtotal: '15.00',
      },
      orderFulfillTime: '2023-07-06T18:34:03',
      closedTime: '2023-07-06T12:59:03',
      localClosedTime: '2023-07-06T18:29:03.811',
      status: 'CLOSED',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'WEB',
      filterStatus: 'CLOSED_ORDERS',
    },
    {
      orderId: '64a6ba29e4b03d4d1e5c8e6f',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: '6935b205-3b71-4cd8-a1a3-3e1d8f16ccde',
      customer: {
        firstName: 'Roy99',
        lastName: 'Justinnn',
        phone: '2321321323',
        email: null,
      },
      createdDate: '2023-07-06T18:27:13.379',
      localCreatedDate: '2023-07-06T18:27:13.384',
      updatedDate: '2023-07-06T18:28:12.151',
      orderTotal: {
        preDiscountSubtotal: 3000,
        subtotal: 3000,
        total: 3210,
        displayTotal: '3.21',
        displaySubtotal: '3.00',
        displayPreDiscountSubtotal: '3.00',
      },
      orderFulfillTime: '2023-07-06T18:33:11',
      closedTime: '2023-07-06T12:58:12',
      localClosedTime: '2023-07-06T18:28:12.151',
      status: 'CLOSED',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'WEB',
      filterStatus: 'CLOSED_ORDERS',
    },
    {
      orderId: '64a6b722e4b03d4d1e5c8e66',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: 'a8bd1f53-6172-4f1f-b78b-50c7cf052151',
      customer: {
        firstName: 'Lochi',
        lastName: 'test order',
        phone: '0788208124',
        email: null,
      },
      createdDate: '2023-07-06T18:14:18.24',
      localCreatedDate: '2023-07-06T18:14:18.242',
      updatedDate: '2023-07-06T18:15:18.032',
      orderTotal: {
        preDiscountSubtotal: 13000,
        subtotal: 13000,
        total: 13000,
        displayTotal: '13.00',
        displaySubtotal: '13.00',
        displayPreDiscountSubtotal: '13.00',
      },
      orderFulfillTime: '2023-07-06T18:30:17',
      closedTime: '2023-07-06T12:45:18',
      localClosedTime: '2023-07-06T18:15:18.032',
      status: 'CLOSED',
      locationName: 'AA Boston QA (Incentivio DON"T EDIT)',
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'APP',
      filterStatus: 'CLOSED_ORDERS',
    },
    {
      orderId: '64a6b02fe4b03d4d1e5c8e1e',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: '27dea69b-aa9a-4642-ab4c-e2adca8f2014',
      customer: {
        firstName: 'Test Order',
        lastName: "Don't Prepare",
        phone: '0784848484',
        email: null,
      },
      createdDate: '2023-07-06T17:44:39.07',
      localCreatedDate: '2023-07-06T17:44:39.071',
      updatedDate: '2023-07-06T17:44:57.24',
      orderTotal: {
        preDiscountSubtotal: 25560,
        subtotal: 25560,
        total: 32640,
        displayTotal: '32.64',
        displaySubtotal: '25.56',
        displayPreDiscountSubtotal: '25.56',
      },
      orderFulfillTime: '2023-07-06T17:56:56',
      closedTime: '2023-07-06T12:14:57',
      localClosedTime: '2023-07-06T17:44:57.24',
      status: 'CLOSED',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'APP',
      filterStatus: 'CLOSED_ORDERS',
    },
    {
      orderId: '64a6afade4b03d4d1e5c8e02',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: 'ee7d0a4c-68f6-443b-86bc-d512223bcfba',
      customer: {
        firstName: 'Test',
        lastName: 'Me',
        phone: '8127553654',
        email: null,
      },
      createdDate: '2023-07-06T17:42:29.455',
      localCreatedDate: '2023-07-06T17:42:29.457',
      updatedDate: '2023-07-06T17:42:35.931',
      orderTotal: {
        preDiscountSubtotal: 51120,
        subtotal: 51120,
        total: 54580,
        displayTotal: '54.58',
        displaySubtotal: '51.12',
        displayPreDiscountSubtotal: '51.12',
      },
      orderFulfillTime: '2023-07-06T18:05:00',
      closedTime: '2023-07-06T12:12:35',
      localClosedTime: '2023-07-06T17:42:35.931',
      status: 'CLOSED',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'WEB',
      filterStatus: 'CLOSED_ORDERS',
    },
    {
      orderId: '64a6ab9be4b092941205f7ba',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      extOrderId: '61ef3c99-9228-48a0-9778-a1701dd573e9',
      customer: {
        firstName: 'Test Order',
        lastName: "Don't Prepare",
        phone: '0784848484',
        email: null,
      },
      createdDate: '2023-07-06T17:25:07.896',
      localCreatedDate: '2023-07-06T17:25:07.897',
      updatedDate: '2023-07-06T17:25:36.532',
      orderTotal: {
        preDiscountSubtotal: 51120,
        subtotal: 51120,
        total: 54580,
        displayTotal: '54.58',
        displaySubtotal: '51.12',
        displayPreDiscountSubtotal: '51.12',
      },
      orderFulfillTime: '2023-07-06T17:30:36',
      closedTime: '2023-07-06T11:55:36',
      localClosedTime: '2023-07-06T17:25:36.532',
      status: 'CLOSED',
      locationName: "Fenway - QA  (Don't Use)",
      orderGoodStanding: true,
      orderGoodStandingStatusDescription: 'Transaction status is OK',
      offerRedeemStatusInGoodStanding: true,
      interventionRequired: false,
      orderSource: 'APP',
      filterStatus: 'CLOSED_ORDERS',
    },
  ],
  totalAmount: 270670.0,
  paging: {
    total: 1357,
    count: 10,
    totalPages: 136,
    currentPage: 0,
  },
  summary: {
    noOfRecords: 1357,
    totalOfOrderTotal: 5.0400768e7,
    totalOfOrderSubtotal: 4.679521e7,
  },
};
